/* Kaffeefinder -- Bewertungslogik
 * =================================================================
 * Reine Funktionen. Kein DOM, kein fetch, keine Theme-Abhaengigkeit --
 * genau deshalb ist sie in kaffee-daten/_import/finder-test.html pruefbar.
 * Die Oberflaeche liegt in lb-kaffeefinder.js.
 *
 * Roeststufen Hell=1 Mittel=2 Dunkel=3 sind dieselben wie in
 * navigation_felder.py und lb-bohnen-kennwerte.liquid. Nicht auseinander
 * laufen lassen.
 */
(function (global) {
  'use strict';

  /* Frage 1 -- das Datenfeld kennt nur drei Werte, die Frage bietet fuenf.
     Ohne diese Abbildung liefern French Press und Mokkakanne null Treffer. */
  var GERAETE = [
    { id: 'siebtraeger', label: 'Siebträger',             feld: 'Siebträger' },
    { id: 'vollautomat', label: 'Vollautomat',            feld: 'Vollautomat' },
    { id: 'filter',      label: 'Filter oder Handfilter', feld: 'Filterkaffee' },
    { id: 'frenchpress', label: 'French Press',           feld: 'Filterkaffee' },
    { id: 'mokka',       label: 'Mokkakanne',             feld: 'Siebträger' }
  ];

  /* Frage 3 -- Zielroestgrad und Staerkezuschlag.
     Milchkaffee bekommt bewusst nur den halben Aufschlag eines Cappuccino:
     ein Cappuccino aus 25 g Espresso ueberdeckt viel mehr als ein
     Milchkaffee, der zu zwei Dritteln Filterkaffee ist. */
  var ZUBEREITUNGEN = {
    espresso:    { label: 'Espresso pur',                    roestgrad: 3, staerke: 1 },
    kleinstark:  { label: 'Klein und stark',                 roestgrad: 3, staerke: 1 },
    cappuccino:  { label: 'Cappuccino oder Latte Macchiato', roestgrad: 3, staerke: 1 },
    crema:       { label: 'Caffè Crema oder großer Becher',  roestgrad: 2, staerke: 0 },
    americano:   { label: 'Americano',                       roestgrad: 2, staerke: 0 },
    milchkaffee: { label: 'Milchkaffee',                     roestgrad: 2, staerke: 0.5 },
    schwarz:     { label: 'Schwarz aus der Kanne',           roestgrad: 1, staerke: -1 }
  };

  var ZUBEREITUNG_JE_GERAET = {
    siebtraeger: ['espresso', 'cappuccino', 'americano'],
    vollautomat: ['espresso', 'cappuccino', 'crema', 'americano'],
    filter:      ['schwarz', 'milchkaffee'],
    frenchpress: ['schwarz', 'milchkaffee'],
    mokka:       ['kleinstark', 'milchkaffee']
  };

  /* Frage 4 -- Erlebnissaetze statt Selbsteinschaetzung. Wer
     "mittelkraeftig" ankreuzen soll, raet; wer "mir ist Kaffee oft zu
     bitter" ankreuzt, erinnert sich. */
  var STAERKEWUNSCH = {
    mild:     { label: 'Lieber mild',     unter: 'Mir ist Kaffee oft zu stark oder zu bitter.', ziel: 1.5 },
    normal:   { label: 'Normal kräftig',  unter: 'Mit dem Üblichen komme ich gut zurecht.',     ziel: 3 },
    kraeftig: { label: 'Richtig kräftig', unter: 'Mir ist Kaffee oft zu dünn.',                 ziel: 4.5 }
  };

  var ROESTSTUFE = { Hell: 1, Mittel: 2, Dunkel: 3 };

  var GEWICHT = { aroma: 45, staerke: 30, roestgrad: 25 };
  var BASIS = 97;            /* 3 Punkte bleiben dem stillen Feinschliff */
  var FEINSCHLIFF_MAX = 3;
  var TIPP_MINDESTPASSUNG = 85;
  var TIPP_MINDESTRANG = 40;
  var KAFFEEZAHL = 91;       /* nur zur Skalierung des Rangbonus */

  /* Verfeinerungsfelder, die als harte Bedingung wirken. Reihenfolge = die,
     in der lockerung() Vorschlaege prueft. */
  /* Zwei Beschriftungen je Feld: eine fuer den Satz "Wenn du ... nachgibst",
     eine fuer den Knopf. Mit nur einer las es sich als "Wenn du bei dem Preis
     nachgibst" und "dem Preis aufheben". */
  var VERFEINERUNG = [
    { feld: 'noten',        beschriftung: 'beim Geschmacksbegriff', knopf: 'Geschmacksbegriff' },
    { feld: 'roestgrad',    beschriftung: 'beim Röstgrad',          knopf: 'Röstgrad' },
    { feld: 'aufbereitung', beschriftung: 'bei der Aufbereitung',   knopf: 'Aufbereitung' },
    { feld: 'mischung',     beschriftung: 'bei Single Origin oder Blend', knopf: 'Single Origin oder Blend' },
    { feld: 'laender',      beschriftung: 'bei der Herkunft',       knopf: 'Herkunft' },
    { feld: 'roesterei',    beschriftung: 'bei der Rösterei',       knopf: 'Rösterei' }
  ];

  function leererZustand() {
    return {
      geraete: [], gruppen: [], zubereitung: [], staerkewunsch: null,
      zucker: false, koffeinfrei: false,
      noten: [], roestgrad: [], aufbereitung: [], mischung: [],
      laender: [], roesterei: [], preisMax: null
    };
  }

  function istVerfeinert(zustand) {
    for (var i = 0; i < VERFEINERUNG.length; i++) {
      if ((zustand[VERFEINERUNG[i].feld] || []).length) return true;
    }
    return zustand.preisMax !== null && zustand.preisMax !== undefined;
  }

  function schnitt(a, b) {
    return (a || []).filter(function (x) { return (b || []).indexOf(x) !== -1; });
  }

  function geraetefelder(geraeteIds) {
    var felder = [];
    (geraeteIds || []).forEach(function (id) {
      GERAETE.forEach(function (g) {
        if (g.id === id && felder.indexOf(g.feld) === -1) felder.push(g.feld);
      });
    });
    return felder;
  }

  /* Skalen, keine Schubladen -- und stufenlos statt in drei Spruengen.
     Vorher galt "bis 0,5 daneben" pauschal als Volltreffer und "bis 1,5"
     pauschal als eine Stufe daneben. Dadurch bekamen Kaffees mit spuerbar
     verschiedenem Abstand exakt dieselbe Punktzahl, und bei haeufigen
     Anfragen standen vier- bis fuenfmal dieselben Prozente untereinander.
     Eine Zahl, die fuenfmal dasselbe sagt, ist ein Filter mit Prozentzeichen.

     Die Gerade laeuft durch dieselben Ankerpunkte wie die alten Stufen --
     0 daneben = 1, eine = 0,6, zwei = 0,2, ab 2,5 = 0. Sie aendert also
     nichts an den ganzzahligen Abstaenden, sondern fuellt nur die Luecken
     dazwischen. Auf vier Stellen gerundet, damit gleiche Abstaende exakt
     gleiche Werte ergeben und die Reihenfolge reproduzierbar bleibt. */
  var NAEHE_ABFALL = 0.4;

  function naehe(ist, ziel) {
    if (typeof ist !== 'number' || typeof ziel !== 'number') return 0;
    var d = Math.abs(ist - ziel);
    var wert = 1 - NAEHE_ABFALL * d;
    if (wert <= 0) return 0;
    return Math.round(wert * 10000) / 10000;
  }

  function zielwerte(zustand) {
    var wunsch = STAERKEWUNSCH[zustand.staerkewunsch];
    var basis = wunsch ? wunsch.ziel : 3;
    var gewaehlt = (zustand.zubereitung || []).filter(function (id) {
      return ZUBEREITUNGEN[id];
    });
    if (!gewaehlt.length) return { roestgrad: 2, staerke: basis };

    var summeR = 0, summeZ = 0;
    gewaehlt.forEach(function (id) {
      summeR += ZUBEREITUNGEN[id].roestgrad;
      summeZ += ZUBEREITUNGEN[id].staerke;
    });
    return {
      roestgrad: summeR / gewaehlt.length,
      staerke: Math.max(1, Math.min(5, basis + summeZ / gewaehlt.length))
    };
  }

  /* Zwei Fragen, nicht eine.

     BREITE: Deckt der Kaffee die gewuenschten Richtungen ab? Bei
     Mehrfachauswahl gilt der beste Treffer voll, jede weitere getroffene
     Gruppe gibt einen Zuschlag -- relativ zur Zahl der gewaehlten Gruppen,
     sonst koennte wer nur eine waehlt niemals 100 Prozent erreichen.

     DICHTE: Wie viel vom Profil des Kaffees liegt ueberhaupt in diesen
     Richtungen? Ein Kaffee aus drei nussigen Noten trifft den Wunsch
     "nussig" staerker als einer mit einer nussigen unter fuenf. Vorher zaehlte
     nur, DASS die Gruppe getroffen war -- deshalb standen bei haeufigen
     Anfragen vier- bis fuenfmal dieselben Prozente untereinander. Ueber die
     91 Kaffees streut die Dichte in vier Stufen (0,33 / 0,50 / 0,67 / 1,00),
     dieses Signal verfiel bisher ungenutzt.

     Die Breite bleibt dominant, damit die Begruendung in Worten weiter
     stimmt: Wer zwei Richtungen waehlt und beide bekommt, steht vor dem, der
     nur eine bekommt -- egal wie dicht. */
  /* Die Dichte wirkt als Abzug, nicht als zweiter Summand -- und der Abzug
     ist kleiner als der Abstand zwischen zwei Breitenstufen. Damit kann ein
     reiner Kaffee, der nur eine gewuenschte Richtung trifft, niemals vor
     einen steigen, der beide trifft.

     Der erste Entwurf addierte Breite und Dichte gewichtet. Der eigene Test
     hat ihn widerlegt: Eine Richtung rein ergab 0,8875, beide Richtungen
     gemischt nur 0,875 -- die Dichte ueberstimmte die Breite. */
  var DICHTE_ABZUG_MAX = 0.12;

  function aromaanteil(gewaehlt, gruppen, gruppenzahl) {
    if (!gewaehlt || !gewaehlt.length) return 1;
    var treffer = schnitt(gewaehlt, gruppen).length;
    if (!treffer) return 0;

    var breite = gewaehlt.length === 1
      ? 1
      : 0.85 + 0.15 * (treffer - 1) / (gewaehlt.length - 1);

    /* Ohne Zaehlung faellt die Dichte weg statt zu bestrafen -- ein Kaffee
       ohne gepflegte Noten soll nicht schlechter dastehen, nur weil Daten
       fehlen. */
    var dichte = 1;
    if (gruppenzahl) {
      var gesamt = 0, drin = 0;
      for (var g in gruppenzahl) {
        gesamt += gruppenzahl[g];
        if (gewaehlt.indexOf(g) !== -1) drin += gruppenzahl[g];
      }
      if (gesamt) dichte = drin / gesamt;
    }
    /* Der Abzug bleibt unter der Schrittweite der Breite. Bei drei gewaehlten
       Gruppen liegen die Stufen enger beieinander, also faellt er kleiner
       aus -- sonst kippte die Rangfolge wieder. */
    var schritt = gewaehlt.length > 1 ? 0.15 / (gewaehlt.length - 1) : 1;
    var abzug = Math.min(DICHTE_ABZUG_MAX, schritt * 0.8);
    return Math.round((breite - abzug * (1 - dichte)) * 10000) / 10000;
  }

  /* Steht der Roestgrad als Schalter, ist er Bedingung und keine Achse mehr.
     Sein Gewicht wandert anteilig auf Aroma und Staerke, damit die Prozente
     weiter bis 100 reichen. */
  function aktiveGewichte(zustand) {
    if (!(zustand.roestgrad || []).length) return GEWICHT;
    var rest = GEWICHT.aroma + GEWICHT.staerke;
    return {
      aroma: GEWICHT.aroma / rest * 100,
      staerke: GEWICHT.staerke / rest * 100,
      roestgrad: 0
    };
  }

  function feinschliff(kaffee, zustand) {
    var punkte = 0;
    if (!istVerfeinert(zustand) && kaffee.einstieg) punkte += 1;
    if (zustand.zucker && (kaffee.gruppen || []).indexOf('Süß') !== -1) punkte += 1;
    if (typeof kaffee.rang === 'number' && kaffee.rang > 0) {
      punkte += Math.max(0, 1 - (kaffee.rang - 1) / (KAFFEEZAHL - 1));
    }
    return Math.min(FEINSCHLIFF_MAX, punkte);
  }

  function erfuelltHart(kaffee, zustand) {
    var felder = geraetefelder(zustand.geraete);
    if (felder.length && !schnitt(felder, kaffee.geraete).length) return false;

    /* Entkoffeinierte sind eine bewusste Wahl, kein Zufallsfund. Ohne
       Schalter bleiben sie draussen, mit Schalter bleiben nur sie. */
    if (!!zustand.koffeinfrei !== !!kaffee.entkoffeiniert) return false;

    if ((zustand.noten || []).length && !schnitt(zustand.noten, kaffee.noten).length) {
      return false;
    }
    if ((zustand.roestgrad || []).length &&
        zustand.roestgrad.indexOf(kaffee.roestgrad) === -1) return false;
    if ((zustand.aufbereitung || []).length &&
        zustand.aufbereitung.indexOf(kaffee.aufbereitung) === -1) return false;
    if ((zustand.mischung || []).length &&
        zustand.mischung.indexOf(kaffee.mischung) === -1) return false;
    if ((zustand.laender || []).length &&
        !schnitt(zustand.laender, kaffee.laender).length) return false;
    if ((zustand.roesterei || []).length &&
        zustand.roesterei.indexOf(kaffee.roesterei) === -1) return false;
    if (zustand.preisMax !== null && zustand.preisMax !== undefined) {
      if (typeof kaffee.euroProKg !== 'number' || kaffee.euroProKg > zustand.preisMax) {
        return false;
      }
    }
    return true;
  }

  function bewerte(kaffee, zustand) {
    var g = aktiveGewichte(zustand);
    var ziel = zielwerte(zustand);
    var a = aromaanteil(zustand.gruppen, kaffee.gruppen, kaffee.gruppenzahl);
    var s = naehe(kaffee.staerke, ziel.staerke);
    var r = g.roestgrad === 0 ? 1 : naehe(ROESTSTUFE[kaffee.roestgrad], ziel.roestgrad);
    var fein = feinschliff(kaffee, zustand);
    var basis = BASIS / 100 * (g.aroma * a + g.staerke * s + g.roestgrad * r);
    return {
      passung: Math.max(0, Math.min(100, Math.round(basis + fein))),
      aroma: a, staerke: s, roestgrad: r, feinschliff: fein
    };
  }

  function ergebnis(kaffees, zustand) {
    var liste = [];
    (kaffees || []).forEach(function (kaffee) {
      if (!erfuelltHart(kaffee, zustand)) return;
      liste.push({ kaffee: kaffee, wertung: bewerte(kaffee, zustand) });
    });
    /* Bei Gleichstand nach Handle -- damit dieselbe Antwort immer dieselbe
       Reihenfolge ergibt und ein geteilter Link stabil bleibt. */
    liste.sort(function (x, y) {
      if (y.wertung.passung !== x.wertung.passung) {
        return y.wertung.passung - x.wertung.passung;
      }
      return x.kaffee.handle < y.kaffee.handle ? -1 : 1;
    });
    return liste;
  }

  function geheimtipp(liste) {
    var beste = null;
    (liste || []).forEach(function (eintrag) {
      var rang = eintrag.kaffee.rang;
      if (typeof rang !== 'number' || rang <= TIPP_MINDESTRANG) return;
      if (eintrag.wertung.passung < TIPP_MINDESTPASSUNG) return;
      if (!beste || eintrag.wertung.passung > beste.wertung.passung) beste = eintrag;
    });
    return beste ? beste.kaffee.handle : null;
  }

  /* Preis-Leistungs-Tipp -- beantwortet eine andere Frage als der Geheimtipp:
     nicht "was uebersieht man", sondern "was kriege ich hier fuers Geld".
     Gemessen wird gegen den Median der GEZEIGTEN Liste, nicht gegen alle 91:
     Wer nach hellen Spezialitaeten sucht, bekommt sonst nie einen Tipp, weil
     das ganze Feld ueber dem Gesamtmedian liegt.
     Wie beim Geheimtipp hoechstens einer -- und nie derselbe Kaffee: zwei
     Abzeichen auf einer Karte heben sich gegenseitig auf. */
  var TIPP_PREISFAKTOR = 0.8;

  function preistipp(liste, geheimtippHandle) {
    var preise = [];
    (liste || []).forEach(function (eintrag) {
      if (typeof eintrag.kaffee.euroProKg === 'number') {
        preise.push(eintrag.kaffee.euroProKg);
      }
    });
    if (preise.length < 3) return null;

    preise.sort(function (a, b) { return a - b; });
    var mitte = Math.floor(preise.length / 2);
    var median = preise.length % 2
      ? preise[mitte]
      : (preise[mitte - 1] + preise[mitte]) / 2;
    var grenze = median * TIPP_PREISFAKTOR;

    var beste = null;
    liste.forEach(function (eintrag) {
      var k = eintrag.kaffee;
      if (k.handle === geheimtippHandle) return;
      if (typeof k.euroProKg !== 'number' || k.euroProKg > grenze) return;
      if (eintrag.wertung.passung < TIPP_MINDESTPASSUNG) return;
      if (!beste || eintrag.wertung.passung > beste.wertung.passung) beste = eintrag;
    });
    return beste ? beste.kaffee.handle : null;
  }

  function mitAenderung(zustand, aenderung) {
    var kopie = {};
    for (var k in zustand) kopie[k] = zustand[k];
    for (var j in aenderung) kopie[j] = aenderung[j];
    return kopie;
  }

  function zaehle(kaffees, zustand, aenderung) {
    var probe = mitAenderung(zustand, aenderung || {});
    var treffer = 0;
    (kaffees || []).forEach(function (kaffee) {
      if (erfuelltHart(kaffee, probe)) treffer++;
    });
    return treffer;
  }

  /* Welche einzelne Bedingung bringt am meisten, wenn man sie fallen laesst?
     Grundlage fuer "Wenn du bei der Staerke einen Schritt nachgibst, kommen
     12 weitere dazu." */
  function lockerung(kaffees, zustand) {
    var jetzt = zaehle(kaffees, zustand, {});
    var beste = null;

    function pruefe(feld, beschriftung, leerwert, knopf) {
      if (feld === 'preisMax') {
        if (zustand.preisMax === null || zustand.preisMax === undefined) return;
      } else if (!(zustand[feld] || []).length) {
        return;
      }
      var aenderung = {};
      aenderung[feld] = leerwert;
      var gewinn = zaehle(kaffees, zustand, aenderung) - jetzt;
      if (gewinn > 0 && (!beste || gewinn > beste.gewinn)) {
        beste = { feld: feld, beschriftung: beschriftung,
                  knopf: knopf || beschriftung, gewinn: gewinn };
      }
    }

    VERFEINERUNG.forEach(function (v) { pruefe(v.feld, v.beschriftung, [], v.knopf); });
    pruefe('preisMax', 'beim Preis', null, 'Preisgrenze');
    return beste;
  }

  global.LBKaffeefinderLogik = {
    GERAETE: GERAETE,
    ZUBEREITUNGEN: ZUBEREITUNGEN,
    ZUBEREITUNG_JE_GERAET: ZUBEREITUNG_JE_GERAET,
    STAERKEWUNSCH: STAERKEWUNSCH,
    ROESTSTUFE: ROESTSTUFE,
    VERFEINERUNG: VERFEINERUNG,
    leererZustand: leererZustand,
    istVerfeinert: istVerfeinert,
    zielwerte: zielwerte,
    naehe: naehe,
    aromaanteil: aromaanteil,
    erfuelltHart: erfuelltHart,
    bewerte: bewerte,
    ergebnis: ergebnis,
    geheimtipp: geheimtipp,
    preistipp: preistipp,
    zaehle: zaehle,
    lockerung: lockerung
  };
}(window));
